"use client";
import React, {useState} from "react";
import styled from "styled-components";
import {Col, Container, Modal, Row} from "react-bootstrap";
import Title from "../Title";
import Button from "../Button";
import {hover} from "@/styles/globalStyleVars";
import {CloseIcon} from "next/dist/client/components/react-dev-overlay/internal/icons/CloseIcon";
import SimpleBar from "simplebar-react";
import Form from "@/components/career/Form";
import HtmlParser from "react-html-parser";
import {Img} from "../Img";

export default function CareerList({ data, desc }) {
  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const [modalData, setModalData] = useState();

  const handleShow = (e) => {
    setShow(true);

    setModalData(e);
  };

  return (
    <StyledComponent className="career-list pt-200 pb-200">
      <Img src={desc?.bg_img} alt={desc?.section_name}/>
      <Container>
        <Row>
          <Col lg={7}>
            <Title
              background={"#FFFFFF"}
              text={desc?.section_name}
              color={"#FFF"}
              version
              number={"II"}
              margin={" 0 0 80px 0"}
            />
          </Col>
        </Row>

        <Row className="career-list__list">
          {data?.length < 1 && (
            <Col sm={{ span: 10, offset: 1 }}>
              <h5>
                Thank you for your interest in working with us. At the moment we
                do not have any job available.
              </h5>
            </Col>
          )}

          {data?.length > 0 &&
            data?.map((e) => (
              <div
                key={e?.ID}
                onClick={() => handleShow(e)}
                className="career-list__list__single"
              >
                <Col md={6} lg={{ span: 5, offset: 1 }}>
                  <h4>{e?.post_title}</h4>
                </Col>
                <Col md={6} lg={4}>
                  {HtmlParser(e?.short_desc)}
                </Col>
                <Col md={6} className={"d-flex justify-content-end"} lg={2}>
                  <Button
                    lineColor={hover}
                    iconBackground={"#FFF"}
                    color={"#FFF"}
                    text={"Apply Today!"}
                    hoverColor={hover}
                  />
                </Col>
              </div>
            ))}
        </Row>
      </Container>

      <Modal
        className={`team-modal team-modal-form  for-home as-career-modal`}
        show={show}
        onHide={handleClose}
      >
        <div className="team-modal__close" onClick={handleClose}>
          <CloseIcon />
        </div>
        <SimpleBar
          autoHide={true}
          style={{
              // maxHeight: window && window.innerHeight + "px",
              maxHeight: "85svh",
              paddingBottom: '60px',
            overflow: "auto",
          }}
        >
          <div className="team-modal__content">
            <Form data={modalData} />
          </div>
        </SimpleBar>
      </Modal>
    </StyledComponent>
  );
}
const StyledComponent = styled.section`
    background-color: #000;
    position: relative;
    overflow: hidden;
    .title {
        p{
            margin-right: 10px;
        }
        h2 {
            padding: 0 !important;

            &:after , &:before{
                display: none !important;
            }
        }
    }
    [data-simplebar] {
        padding-bottom: 60px;
    }

    .career-list__list {
        h5 {
            font-size: 32px;
            line-height: 36px;
            color: #fff;
            font-weight: 500;
        }

        &__single {
            display: flex;
            padding-bottom: 30px;
            margin-bottom: 30px;
            width: 100%;
            position: relative;
            flex-wrap: wrap;

            &:nth-last-child(1) {
                margin-bottom: 0;

                &:after {
                    display: none;
                }
            }

            &:after {
                content: "";
                position: absolute;
                height: 1px;
                width: calc(100% - 9.5%);
                bottom: 0;
                background-color: rgba(255, 255, 255, 0.2);
                right: 0;
            }

            h4 {
                color: #fff;
                font-size: 24px;
                line-height: 32px;
                font-weight: 400;
            }

            ul {
                li {
                    color: #fff;

                    &:not(:nth-last-child(1)) {
                        margin-bottom: 5px;
                    }
                }
            }
        }
    }

    @media (max-width: 991px) {
        .justify-content-end {
            justify-content: start !important;
        }

        .career-list__list__single {
            &:after {
                width: calc(100% - 15px);
            }
        }
    }
    @media (max-width: 767px) {
        .col-md-6:not(:nth-last-child(1)) {
            margin-bottom: 30px;
        }
    }
`;
